module.exports = __webpack_public_path__ + "media/src/fonts/GothamPro-e0cf8ca40728224ce13d7f17cd4bca24.woff";